
import {
  defineComponent,
  reactive,
  computed,
  ref,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import BackgroundPattern from '@/components/BackgroundPattern.vue';
import SectionSpacerClouds from '@/components/partials/SectionSpacerClouds.vue';

export default defineComponent({
  components: {
    BackgroundPattern,
    SectionSpacerClouds,
  },

  props: {
    error: {
      type: Number,
      required: true,
    },
  },

  setup() {
    const {
      ioappConfig: {
        themeUri,
        svg,
      },
    } = window;

    const store = useStore();
    store.dispatch('pages/setPageType', null);

    const clouds = ref<InstanceType<typeof SectionSpacerClouds>>();
    const pattern = ref<InstanceType<typeof HTMLElement>>();
    const pageType = computed<string>(() => store.getters['pages/pageType']);

    const header = reactive({
      $el: null as null | HTMLElement,
    });

    const minHeight = reactive({ value: null as number | null });
    const minHeightPx = computed(() => (minHeight.value ? `min-height:${minHeight.value}px` : null));
    const sloganSvg = computed(() => {
      if (pageType.value !== 'other') {
        const pt: string = pageType.value;
        return atob(svg.hero[pt]);
      }

      return null;
    });
    const hashtagSvg = computed(() => atob(svg.hero.hashtag));

    const setMinHeight = () => {
      minHeight.value = window.innerHeight;

      if (header.$el) {
        minHeight.value -= header.$el.offsetHeight;
      }

      if (clouds.value && clouds.value.$el) {
        minHeight.value -= clouds.value.$el.scrollHeight;
        minHeight.value += window.innerWidth * 0.0515;
      }
    };

    onMounted(() => {
      if (pageType.value === 'common') {
        header.$el = document.querySelector('header');
        window.addEventListener('resize', setMinHeight);
        window.addEventListener('load', setMinHeight);
        setMinHeight();
        for (let i = 100; i < 1000; i += 100) {
          setTimeout(setMinHeight, i);
        }
      } if (pattern.value) {
        pattern.value.style.backgroundImage = `url('${themeUri}/assets/img/hero-pattern.svg')`;
      }
    });

    onBeforeUnmount(() => {
      if (pageType.value === 'common') {
        window.removeEventListener('resize', setMinHeight);
        window.removeEventListener('load', setMinHeight);
      }
    });

    return {
      header,
      minHeightPx,
      pageType,
      clouds,
      pattern,
      sloganSvg,
      hashtagSvg,
    };
  },
});
